var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip-box"},[_c('el-tooltip',{attrs:{"effect":"dark","placement":"top"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("default")],2),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label)+" "),_c('i',{staticClass:"el-icon-question"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }